module.exports = __webpack_public_path__ + "img/2.3be70d56.svg";